
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const VerticalGraph = ({border_color="#9747ff",graph_data}) => {
    const data =  {
        labels: graph_data?.linkedin?.labels,
        datasets: [{
            label: 'Facebook',
            data: graph_data?.facebook?.impressions,
            borderColor: '#D3A4FF',
            backgroundColor:"#fbf6ff",
            fill: true,

            tension: 0.1,
            borderWidth: 1
            
          },{
            label: 'Instagram',
            data: graph_data?.instagram?.impressions,
          
            borderColor: '#FFB1E0',
            tension: 0.1,
            borderWidth: 1,
            backgroundColor:"#fbf6ff",
            fill: true,
          },
          {
            label: 'Twitter',
            data: graph_data?.twitter?.impressions,
         
            borderColor: '#95F3FA',
            tension: 0.1,
            borderWidth: 1,
            backgroundColor:"#fbf6ff",
            fill: true,
          },
          {
            label: 'LinkedIn',
            data: graph_data?.linkedin?.impressions,
            borderColor: '#FFE58A',
            tension: 0.1,
            borderWidth: 1,
            backgroundColor:"#fbf6ff",
            fill: true,
          }
        
        
        ],
       
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                display:true
            },
            x: {
                grid:{
                    display:false,
                    drawBorder:true
                }
            },
            
        },
        plugins: {
            legend: {
                display: false // Hide the legend
            }
        }

    }





    return <Line data={data} options={options}  />;
};

export default VerticalGraph;
